import { Modal } from 'common/components'

const DeleteKeywordModal = ({ visible, onCancel, onOk, keyword }) => {
  return (
    <>
      <Modal visible={visible} title="Delete Keyword" onCancel={onCancel} onOk={onOk} okText="Delete" width={600}>
        <p>
          Are you sure you want to delete <b>{keyword}</b>?
        </p>
        <p>This action cannot be undone.</p>
      </Modal>
    </>
  )
}

export default DeleteKeywordModal
